import { OdataFieldTwoValueOperator } from './OdataFieldTwoValueOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldOperatorIndexOf extends OdataFieldTwoValueOperator {
  constructor(field: IOdataField, match: IOdataField) {
    super(field, match, 'indexof');
  }
}
